/** Copied from `libs/shared/src/assets/images`, served at `/assets/images`. */
export const UPGRADE_PLAN_IMAGE = '/assets/images/upgrade-plan-dialog.png';

export const UPGRADE_PLAN_HEADER_TITLE = 'Upgrade plan';

export const UPGRADE_PLAN_SUBTITLE =
  'Upgrade and keep going where you left off.';

export const UPGRADE_PLAN_FEATURES: string[] = [
  'Every search filter, unlocked',
  'Export and enrich your results',
  'Work without hitting limits',
  'Bring your whole team in',
];
